
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 4h16v4H4V4zm4 6H4v4h4v-4zm0 5.966H4V20h4v-4.034zM10 20v-4.034h10V20H10zm10 2H2V2h20v20h-2zm0-8H10v-4h10v4z"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 4h16v4H4V4zm4 6H4v4h4v-4zm0 5.966H4V20h4v-4.034zM10 20v-4.034h10V20H10zm10 2H2V2h20v20h-2zm0-8H10v-4h10v4z","fill":"#2A333D"}}),_c('path',{attrs:{"d":"M4 4V3H3v1h1zm16 0h1V3h-1v1zm0 4v1h1V8h-1zM4 8H3v1h1V8zm4 2h1V9H8v1zm-4 0V9H3v1h1zm0 4H3v1h1v-1zm4 0v1h1v-1H8zm0 1.966h1v-1H8v1zm-4 0v-1H3v1h1zM4 20H3v1h1v-1zm4 0v1h1v-1H8zm2 0H9v1h1v-1zm0-4.034v-1H9v1h1zm10 0h1v-1h-1v1zM20 20v1h1v-1h-1zM2 22H1v1h1v-1zM2 2V1H1v1h1zm20 0h1V1h-1v1zm0 20v1h1v-1h-1zm-12-8H9v1h1v-1zm10 0v1h1v-1h-1zm-10-4V9H9v1h1zm10 0h1V9h-1v1zM10 3H4v2h6V3zm0 2h10V3H10v2zm9-1v4h2V4h-2zm-9 5h10V7H10v2zm0-2H8v2h2V7zM4 9h4V7H4v2zM3 4v4h2V4H3zm5 5H4v2h4V9zm-5 1v4h2v-4H3zm1 5h4v-2H4v2zm3-5v4h2v-4H7zm1 4.966H4v2h4v-2zm-5 1V20h2v-4.034H3zM4 21h4v-2H4v2zm3-5.034V20h2v-4.034H7zM11 20v-4.034H9V20h2zm9-5.034H10v2h10v-2zm-1 1V20h2v-4.034h-2zM10 21h10v-2H10v2zm10 0H2v2h18v-2zM3 22V2H1v20h2zM2 3h8V1H2v2zm18-2H10v2h10V1zm2 0h-2v2h2V1zm1 3V2h-2v2h2zm0 4V4h-2v4h2zm0 2V8h-2v2h2zm0 4v-4h-2v4h2zm0 1.966V14h-2v1.966h2zM23 20v-4.034h-2V20h2zm0 2v-2h-2v2h2zm-3 1h2v-2h-2v2zm-10-8h10v-2H10v2zm1-1v-4H9v4h2zm9-5H10v2h10V9zm-1 1v4h2v-4h-2z","fill":"#2A333D","mask":"url(#a)"}})])
          )
        }
      }
    